import { onDocumentReady } from "./Async";

export type StaticConfig = {
  isUnitTestRun: boolean;
  isAuthoring: boolean;
  isMobile: boolean;
  isJsDebug: boolean;
  isOffline: boolean;
  isPublic: boolean;
  isSalesforceNative: boolean;
  parentFrameOrigin: string;
  publicGalleryLink: string;
  showPagePathPrefix: string;
  vizqlPrefix: string;
};

declare global {
  // eslint-disable-next-line no-var
  var staticConfig: StaticConfig | undefined;
}

export function readStaticConfig(): Promise<StaticConfig> {
  return new Promise((resolve, reject) => {
    onDocumentReady(() => {
      const config = parseFromDoc(document);
      if (config) {
        resolve(config);
      } else {
        reject(new Error("Failed to parse staticConfig from document"));
      }
    });
  });
}

function parseFromDoc(doc: Document): StaticConfig | null {
  const staticConfigContainer = doc.getElementById("staticConfigContainer");
  if (staticConfigContainer) {
    const jsonContent = staticConfigContainer.textContent;
    if (jsonContent) {
      return JSON.parse(jsonContent) as StaticConfig;
    }
  }
  return null;
}

export function isUnitTestRun(doc: Document): boolean {
  return parseFromDoc(doc)?.isUnitTestRun || false;
}

export function isAuthoring(doc: Document): boolean | null {
  return parseFromDoc(doc)?.isAuthoring || null;
}

export function isMobile(doc: Document): boolean | null {
  return parseFromDoc(doc)?.isMobile || null;
}

export function isJsDebug(doc: Document): boolean | null {
  return parseFromDoc(doc)?.isJsDebug || null;
}

export function isPublic(doc: Document): boolean | null {
  return parseFromDoc(doc)?.isPublic || null;
}

export function isSalesforceNative(doc: Document): boolean | null {
  return parseFromDoc(doc)?.isSalesforceNative || null;
}

export function parentFrameOrigin(doc: Document): string | null {
  return parseFromDoc(doc)?.parentFrameOrigin || null;
}

export function publicGalleryLink(doc: Document): string | null {
  return parseFromDoc(doc)?.publicGalleryLink || null;
}

export function showPagePathPrefix(doc?: Document): string | null {
  return doc ? parseFromDoc(doc)?.showPagePathPrefix || null : null;
}

export function vizqlPrefix(doc?: Document): string | null {
  return doc ? parseFromDoc(doc)?.vizqlPrefix || null : null;
}

export function isOffline(doc: Document): boolean | null {
  return doc ? parseFromDoc(doc)?.isOffline || null : null;
}
